export default {
  bankpay: {
    title: "Выписки банка, платежные документы",
    bankStat: {
      modal: {
        title: "Выписка банка"
      },
      form: {
        datebank: {
          title: "Дата по банку"
        },
        quantity: {
          title: "Кол-во платежей"
        },
        summa: {
          title: "Сумма платежей"
        },
        accountid: {
          title: "Р/счет-получатель"
        }
      }
    },
    payDocEdit: {
      modal: {
        title: "Платежный документ"
      },
      form: {
        paymentStatus: {
          title: "Платеж"
        },
        paynumber: {
          title: "№ документа"
        },
        okpo: {
          title: "ОКПО"
        },
        datepay: {
          title: "Дата оплаты"
        },
        codefirme: {
          title: "Отправитель"
        },
        summa: {
          title: "Сумма"
        },
        astatus: {
          title: "сумма включает ком. сбор"
        },
        kindpay: {
          title: "Способ оплаты"
        },
        mess: {
          title: "Примечание"
        }
      }
    },
    uploadFiles: {
      modal: {
        title: "Загрузка файлов"
      },
      form: {
        encoding: {
          title: "Кодировка"
        },
        uploadfile: {
          title: "Файлы для загрузки"
        }
      }
    },
    confirm: {
      modal: {
        title: "Организация-отправитель"
      },
      form: {
        info: {
          title:
            "Выберите организацию, отправившую платеж с указанными реквизитами"
        },
        sender: {
          title: "Отправитель"
        },
        mfo: {
          title: "МФО"
        },
        rcount: {
          title: "Расчетный счет"
        },
        summa: {
          title: "Сумма платежа"
        },
        okpo: {
          title: "ОКПО"
        },
        codefirme: {
          title: "Организация"
        },
        alienpay: {
          title: "Чужой платеж"
        },
        saveforsender: {
          title: "Запомнить выбор для данного отправителя"
        }
      }
    },
    bankStatColumn: {
      headers: {
        bankStatement: "Выписка банка",
        postRecording: "Занесение записи"
      }
    },
    payDocColumn: {
      headers: {
        payDoc: "Платежные документы",
        postRecording: "Занесение записи"
      }
    },
    deleteBankStat: {
      title: "Сторнирование",
      message: "Удалить выбранную банковскую выписку и все ее платежи?"
    },
    deleteModal: {
      title: "Удаление",
      message: "Удалить запись?"
    },
    checkImport: {
      rcount: "р/счет"
    },
    bankStatPostingConfirm: {
      title: "Разнести",
      message:
        "Завершить работу с выпиской банка и разрешить связывать указанные платежи с пачками?"
    }
  }
};
